import Immutable from 'seamless-immutable';
import {
    JOURNAL_DATA_REQUEST,
    JOURNAL_DATA_SUCCESS,
    JOURNAL_DATA_ERROR,
    JOURNAL_UPDATE_REQUEST,
    JOURNAL_UPDATE_SUCCESS,
    JOURNAL_UPDATE_ERROR,
    JOURNAL_CREATE_REQUEST,
    JOURNAL_CREATE_SUCCESS,
    JOURNAL_CREATE_ERROR,
} from 'Actions/journal';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    journal: {
        id: null,
        title: null,
        publisher: null,
        founder: null,
        issn_print: null,
        issn_online: null,
        issued_since_month: null,
        issued_since_year: null,
        is_active: null,
    },
});

export default function journalDataReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case JOURNAL_DATA_REQUEST:
        case JOURNAL_UPDATE_REQUEST:
        case JOURNAL_CREATE_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case JOURNAL_DATA_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
                journal: action.payload.data,
            });

        case JOURNAL_UPDATE_SUCCESS:
        case JOURNAL_CREATE_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
                journal: {},
            });

        case JOURNAL_DATA_ERROR:
        case JOURNAL_UPDATE_ERROR:
        case JOURNAL_CREATE_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/journalDataReducer.js